<div class="nav-search-wrapper">
  <!-- Search Trigger Button -->
  <button type="button" class="nav-search-trigger-btn" [class.active]="isOpen" (click)="toggleSearch()"
    aria-label="Search" [attr.aria-expanded]="isOpen" title="Search movies, TV shows, and celebrities">
    <svg class="nav-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  </button>

  <!-- Search Popup Dropdown -->
  <div class="nav-search-dropdown" *ngIf="isOpen">
    <!-- Search Input Bar -->
    <div class="nav-search-input-box">
      <svg class="search-field-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2.2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>

      <input #searchInput type="text" class="nav-search-input" [formControl]="searchControl"
        (keydown)="onKeyDown($event)"
        [placeholder]="languageService.t('searchPlaceholder') || 'Search movies, TV, people...'" autocomplete="off"
        spellcheck="false" />

      <button *ngIf="searchControl.value" type="button" class="clear-btn"
        (click)="searchControl.setValue(''); searchInput.focus()" aria-label="Clear search">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <button type="button" class="search-submit-btn" (click)="submitSearch()" title="Search">
        <span>Go</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <!-- Loading Indicator -->
    <div class="nav-search-loading" *ngIf="isLoading">
      <div class="nav-loading-spinner"></div>
      <span>Searching cinema database...</span>
    </div>

    <!-- Autocomplete Suggestions List -->
    <div class="nav-suggestions-list" *ngIf="!isLoading && suggestions.length > 0">
      <button type="button" class="nav-suggestion-item" *ngFor="let item of suggestions; let i = index"
        [class.selected]="selectedIndex === i" (click)="selectSuggestion(item)" (mouseenter)="selectedIndex = i">
        <img class="suggestion-poster" [src]="getPosterImage(item)" [alt]="getDisplayTitle(item)"
          (error)="onImageError($event)" loading="lazy" />

        <div class="suggestion-info">
          <div class="suggestion-title-row">
            <span class="suggestion-title">{{ getDisplayTitle(item) }}</span>
          </div>
          <span class="suggestion-meta" *ngIf="getMetaInfo(item)">{{ getMetaInfo(item) }}</span>
        </div>

        <svg class="suggestion-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <!-- View All Results Action -->
      <button type="button" class="view-all-results-btn" (click)="submitSearch()">
        <span>View all results for "{{ searchControl.value }}" &rarr;</span>
      </button>
    </div>

    <!-- Empty Results State -->
    <div class="nav-empty-state"
      *ngIf="!isLoading && (searchControl.value ?? '').trim().length >= 2 && suggestions.length === 0">
      <span>No results found for "{{ searchControl.value }}"</span>
    </div>

    <!-- Hint when input empty -->
    <div class="nav-hint-state" *ngIf="!(searchControl.value ?? '').trim()">
      <span class="hint-title">Quick Search</span>
      <span class="hint-desc">Type any film, TV series, or celebrity name</span>
    </div>
  </div>
</div>